export default {
  eyebrow: 'Partner-Portal',
  title: 'Branding',
  description: 'Das Erscheinungsbild Ihres White-Label-Portals und Ihrer Login-Seite.',
  page: {
    read_only_notice: 'Nur Lesezugriff. Klicken Sie auf Bearbeiten, um Werte zu ändern.',
    editing_notice: 'Bearbeitung — Änderungen sind für Ihr Team und Ihre Kunden sichtbar.',
  },
  branding: {
    scope_hint:
      'Gilt für Ihr White-Label-Portal und Ihre Login-Seite — nicht für die Storefronts Ihrer Restaurants, die pro Restaurant gebrandet werden.',
    upload: 'Logo hochladen',
    logo: {
      label: 'Logo',
      hint: 'Wird auf Ihren White-Label-Oberflächen angezeigt.',
    },
    circle_logo: {
      label: 'Favicon / rundes Logo',
      hint: 'Quadratisches Logo für Favicon und Avatar. Optional — kann entfernt werden.',
    },
    splash_image: {
      label: 'Login-Bild',
      hint: 'Wird auf Ihrer White-Label-Login-Seite angezeigt. Empfohlen: mindestens 1200px Breite. Optional — kann entfernt werden.',
    },
    footer_note: 'Weitere Branding-Optionen (Sekundärfarben) folgen später.',
  },
  form: {
    primary_color: {
      label: 'Primäre Markenfarbe',
      hint: 'Bestimmt das Erscheinungsbild Ihres Partner-Portals und Ihrer Login-Seite.',
    },
    dashboard_subdomain: {
      label: 'Partner-Login-Kürzel',
      hint: 'Kleingeschriebener Slug — kennzeichnet Ihr Branding im Login-Link für das Team (?partner=…).',
      placeholder: 'partner-name',
    },
    login_url: {
      label: 'Login-Link für das Team',
      hint: 'Teilen Sie diesen Link mit Ihrem Team — er öffnet die Login-Seite mit Ihrem Branding.',
    },
    file: {
      label: 'Bild',
    },
  },
  login_url_warning: {
    title: 'Login-Link für das Team ändern?',
    description:
      'Der Login-Link für Ihr Team ändert sich zu {{url}}. Teilen Sie ab jetzt den neuen Link — der alte zeigt Ihr Branding nicht mehr an.',
    description_no_url:
      'Der Login-Link für Ihr Team ändert sich. Teilen Sie ab jetzt den neuen Link — der alte zeigt Ihr Branding nicht mehr an.',
  },
  login_url_changed: {
    title: 'Login-Link für das Team geändert',
    description:
      'Ihr Team meldet sich jetzt unter {{url}} an. Speichern Sie den neuen Link und teilen Sie ihn mit Ihrem Team.',
  },
  buttons: {
    edit: 'Bearbeiten',
    cancel: 'Abbrechen',
    save: 'Speichern',
  },
  toasts: {
    load_error: 'Ihr Branding konnte nicht geladen werden.',
    failed_to_save_changes: 'Änderungen konnten nicht gespeichert werden',
    changes_got_saved: 'Änderungen wurden gespeichert',
    logo_uploaded: 'Logo hochgeladen',
    logo_upload_failed: 'Logo konnte nicht hochgeladen werden',
    logo_removed: 'Logo entfernt',
    logo_remove_failed: 'Logo konnte nicht entfernt werden',
    file_too_large: 'Die Datei ist zu groß. Maximale Größe: {{max}} MB.',
    image_too_narrow: 'Das Login-Bild muss mindestens {{min}} px breit sein.',
  },
};
